<template>
  <v-dialog max-width="330" v-model="isTexteditundoDialog" @click:outside="close">
    <v-card class="container-text-undo px-5 py-3" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-3 mb-2" :cols="12" align="start" justify="start">
          <span class="text-undo-title">{{ 'Discard changes?' }}</span>
        </v-col>
        <v-row class="d-flex flex-nowrap container-btn my-4 mx-5" no-gutters align="start" justify="start">
          <v-btn width="120" height="40" elevation="0" color="#ff575f" @click="undo" class="mr-5">
            {{ 'Confirm' }}
          </v-btn>
          <v-btn width="120" height="40" elevation="0" color="#869399" @click="close">
            {{ $t('Cancel') }}
          </v-btn>
        </v-row>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TexteditundoDialog',
  props: {
    isTexteditundoDialog: Boolean,
  },
  data() {
    return {}
  },
  methods: {
    undo() {
      this.$emit('undo', 'Undo')
    },
    close() {
      this.$emit('close', 'Undo')
    },
  },
  computed: {},
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.container-text-undo {
  border-radius: 24px !important;
}
.text-undo-title {
  font-weight: bold;
  font-size: 20px;
  color: white;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
</style>
